// extracted by mini-css-extract-plugin
module.exports = {"submit":"_1_yKI","verification":"_2hQa8","dash":"_2qhhl"};